import { NormalCode } from './../../../../shared/utils/normalCode';
import { NzMessageService } from 'ng-zorro-antd';
import { loginUrls } from '../../../../shared/urls/loginUrls';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '@delon/theme';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { CacheService } from '@delon/cache';

@Component({
  selector: 'header-user',
  template: `
    <div
      class="alain-default__nav-item d-flex align-items-center px-sm"
      nz-dropdown
      nzPlacement="bottomRight"
      [nzDropdownMenu]="userMenu"
    >
      <nz-avatar [nzSrc]="srcUrl" nzSize="small" class="mr-sm"></nz-avatar>
      {{ settings.user.name }}
    </div>
    <nz-dropdown-menu #userMenu="nzDropdownMenu">
      <div nz-menu class="width-sm">
        <!-- <div nz-menu-item routerLink="/pro/account/center">
          <i nz-icon nzType="user" class="mr-sm"></i>
          {{ 'menu.account.center' | translate }}
        </div> -->
        <div nz-menu-item routerLink="/account-settings">
          <i nz-icon nzType="setting" class="mr-sm"></i>
          {{ 'menu.account.settings' | translate }}
        </div>
        <!-- <div nz-menu-item routerLink="/exception/trigger">
          <i nz-icon nzType="close-circle" class="mr-sm"></i>
          {{ 'menu.account.trigger' | translate }}
        </div> -->
        <li nz-menu-divider></li>
        <div nz-menu-item (click)="logout()">
          <i nz-icon nzType="logout" class="mr-sm"></i>
          {{ 'menu.account.logout' | translate }}
        </div>
      </div>
    </nz-dropdown-menu>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderUserComponent implements OnInit {
  srcUrl: string;

  constructor(
    public settings: SettingsService,
    private router: Router,
    private http: HttpClient,
    private message: NzMessageService,
    private cacheService: CacheService,
    private settingsService: SettingsService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
  ) { }

  ngOnInit(): void {
    this.srcUrl = xtwhUrls.files.downloadFile_icon + '?fileName=' + this.settings.user.avatar;
  }

  logout() {
    this.http.post(loginUrls.logout, '').subscribe((response: any) => {
      console.log(response);
      if (response.err_code === NormalCode.NORMAL_CODE) {
        this.message.create('success', response.err_msg);
        // this.cacheService.clear();
        // this.tokenService.clear();
        // this.settingsService.setUser({});
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigateByUrl(this.tokenService.login_url!);
      } else {
        this.message.create('error', response.err_msg);
      }
    });
  }
}
